import { Component } from '@angular/core';
import { TransferHttpService } from '../../services/transfer-http/transfer-http.service';
import { PermissionsService } from '../../services/permissions/permissions.service';
import { take } from 'rxjs/operators';
import { AimsCommonTableHeader, AimsCommonTablePermissions, TableRowDelete, TableRowUpdate } from '@aims/common-components';

const MAX_MACS_ALLOWED: number = 5;

@Component({
  selector: 'mac-addresses',
  templateUrl: './macAddresses.component.html',
})
export class MacAddressesComponent {

  constructor(private transferHttp: TransferHttpService,
    public permissions: PermissionsService) { }

  // AimsCommonTable setup
  tablePermissions: AimsCommonTablePermissions = {
    create: true,
    update: true,
    delete: true,
    filter: false
  };
  tableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', },
    { key: 'macAddress', label: 'MAC Address', type: 'dynamic', },
    { key: 'deviceType', label: 'Device Type', type: 'string', },
  ];
  defaultMac = new MacAddress();

  //***************************
  // Variables
  //***************************
  user = this.transferHttp.getCache('user');
  macRule: { [key: string]: RegExp } = { "A": /[0-9A-Fa-f]/ };
  macRule2 = { 'A': { pattern: new RegExp( '\[0-9A-Fa-f\]' )}};
  totalMacs: number = 0;

  //Grid
  macAddresses = this.transferHttp.getSingle('User/GetUserMacAddresses');
  editedRowIndex: number;
  editedMacAddress: MacAddress;

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = true;

  //***************************
  // Functions
  //***************************
   public handleRowAdd(update: TableRowUpdate): void {
    let newMac: MacAddress = update.newRow as MacAddress;
    this.saveMac(newMac, true);
  }

  public handleRowUpdate(update: TableRowUpdate): void {
    let updatedMac: MacAddress = update.newRow as MacAddress;
    this.saveMac(updatedMac, false);
  }

  public handleRowDelete(deleted: TableRowDelete) {
    const row = deleted.row as MacAddress;
    this.spinnerText = "Deleting...";
    this.showSpinner = true;

    this.transferHttp.delete('Common/DeleteArctecMac?hughesNetMacId=' + row.hughesNetMacId).pipe(take(1)).subscribe(_ => {
      this.macAddresses = this.transferHttp.getSingle('User/GetUserMacAddresses');
      this.refreshMacs();
    });
 }

  public saveMac(mac: MacAddress, isNew) {
    //Check if they have more than max macs
    if ((isNew && this.totalMacs >= MAX_MACS_ALLOWED) || (this.totalMacs > MAX_MACS_ALLOWED)) {
      alert("You already have " + this.totalMacs + " Mac Addresses on file, you are only allowed " + MAX_MACS_ALLOWED + ". Delete the extras and try again");
    }
    else if (mac.macAddress == null || mac.macAddress.indexOf(' ') != -1 || mac.macAddress.replace(/:/g, '').length != 12) {
      alert("MAC Address is improperly formed.  MAC must have 12 characters.");
    }
    else if (mac.deviceType == null) {
      alert("Device Type is required!");
    }
    else {
      this.spinnerText = "Saving...";
      this.showSpinner = true;

      if (isNew) {
        this.transferHttp.post('Common/CreateNewArctecMac?macAddress=' + mac.macAddress + '&deviceType=' + mac.deviceType, null).pipe(take(1)).subscribe({
          next: _ => {
            this.macAddresses = this.transferHttp.getSingle('User/GetUserMacAddresses');
            this.refreshMacs();
          },
          error: err => { this.showSpinner = false; }
        });
      }
      else {
        this.transferHttp.put('Common/SaveArctecMac', mac).pipe(take(1)).subscribe({
          next: _ => {
          this.macAddresses = this.transferHttp.getSingle('User/GetUserMacAddresses');
          this.refreshMacs();
        },
        error: err => { this.showSpinner = false; },
        });
      }
    }
  }

	refreshMacs() {
    this.spinnerText = "Loading...";
    this.showSpinner = true;
    this.macAddresses.subscribe(macs => {
      this.showSpinner = false;
      this.totalMacs = macs.length;
    });
  }

  //***************************
  // Init
  //***************************

  ngOnInit(): void {
    this.refreshMacs();
  }

}

class MacAddress {
  constructor(hughesNetUserId?: number, macAddress?: string, deviceType?: string) {
    this.hughesNetUserId = hughesNetUserId;
    this.macAddress = macAddress;
    this.deviceType = deviceType;
  }

  macAddress: string;
  deviceType: string;
  hughesNetUserId: number;
  hughesNetMacId: number;
}
